import type { IBaseCart } from "./types/IBaseCart";
import type { ShopifyCartData } from "./types/ICartApi";

export let prePatchedFetch = window.fetch;

const cartAjaxApiPaths = /\/cart\/(?:add|update|change|clear)(?:\.js|\.json)?$/;

function isShopifyCartData(data: unknown): data is ShopifyCartData {
  return typeof data === 'object' && data !== null && 'token' in data && 'items' in data && Array.isArray(data.items);
}

export function monitorForCartChanges(cart: IBaseCart) {
  console.log("Monitoring for cart changes")
  const callback = (res: unknown) => {
    void cart.notifyCartUpdatedExternally(isShopifyCartData(res) ? res : undefined);
  };
  detectViaXhrPatch(callback);
  detectViaFetchPatch(callback);
}

function detectViaXhrPatch(callback: (res?: unknown) => void) {

  if (!window.XMLHttpRequest) {
    return false;
  }

  const originalOpen = window.XMLHttpRequest.prototype.open;

  function handleResponse(xhr: XMLHttpRequest) {
    try {
      const jsonData = JSON.parse(xhr.responseText);
      callback(jsonData)
    } catch (e) {
      console.error("Error handling response", e)
      callback();
    }
  }

  function findPathname(url: string | URL): string {
    if(url instanceof URL) {
      return url.pathname;
    }

    try {
      if(url.startsWith('//')) {
        return new URL(window.location.protocol + url).pathname;
      }
      return new URL(url, window.location.href).pathname;
    } catch (e) {
      console.error("Error finding pathname", url, e)
    }

    return url;
  }

  function patchedOpen(this: XMLHttpRequest, ...args: Parameters<typeof XMLHttpRequest.prototype.open>) {

    const pathname = findPathname(args[1])

    if (!pathname.match(cartAjaxApiPaths)) {
      return originalOpen.apply(this, args);
    }


    this.addEventListener('load', () => {
      handleResponse(this);
    });

    return originalOpen.apply(this, args);
  }

  // @ts-expect-error -- difficult to solve
  window.XMLHttpRequest.prototype.open = patchedOpen;

  return true;
}

function detectViaFetchPatch(callback: (res?: unknown) => void): boolean {
  async function handleResponse(res: Response) {

    if (!res.url) {
      return;
    }

    const url = new URL(res.url);

    if (url.pathname.match(cartAjaxApiPaths)) {
      try {
        callback(await res.json());
      } catch (e) {
        console.error("Error handling response", e)
        callback();
      }
      
    }
  }
  // Patch fetch() to intercept response
  if (!window.fetch || typeof window.fetch !== 'function') {
    return false;
  }
  const originalFetch = window.fetch;
  prePatchedFetch = originalFetch;

  window.fetch = async (...args: Parameters<typeof fetch>) => originalFetch(...args)
    .then(async (response) => {
      void handleResponse(response.clone());
      return response;
    })

  return true;
}